import { FieldValues, useFormContext } from 'react-hook-form';
import { SERVICE_PROVIDERS } from 'modules/graphql/types';
import { useModalsContext, useSendingPlatformsQueryContext } from '../../../../contexts';
import { useUpdateAccount } from '../../../../hooks';
import { SPARKPOST } from '../../../../constants';
import { ESP_ACCOUNT_PAYLOAD_FIELDS } from '../../../../types';
import { createSparkpostPayload, getEspRadioOptionsForSendingPlatform } from '../../../../utils';
import { AccountTypesRadioListField } from '../../Shared/AccountTypesRadioListField';
import { ConnectedInputField } from '../../Shared/ConnectedInputField';
import { GreyBorderedContainer } from '../../styles';
import { ClearableConnectedInputField } from '../../Shared/ClearableConnectedInputField';
import { SparkpostEliteRadioLabel } from './SparkpostEliteRadioLabel';
import { EditModalRHF } from '../../Shared/EditModalRHF';

const { NAME, API_KEY, ESP, BINDING, API_ENDPOINT, EDIT_API_KEY } = ESP_ACCOUNT_PAYLOAD_FIELDS;

export const TEXT = {
  CONFIRM_BUTTON: 'Save account',
};

export const SparkpostEditModal = () => {
  const { hideModal } = useModalsContext();
  const { espDefinitions = [] } = useSendingPlatformsQueryContext();
  const {
    formState: { defaultValues = {} },
  } = useFormContext();

  const { updateAccount } = useUpdateAccount();
  const esp = defaultValues[ESP];

  const espOptions = getEspRadioOptionsForSendingPlatform(SPARKPOST, espDefinitions, esp).map(
    (option) =>
      option.id === SERVICE_PROVIDERS.SPARKPOST_ELITE
        ? { ...option, name: SparkpostEliteRadioLabel }
        : option,
  );

  const onSubmit = (values: FieldValues) => {
    const payload = createSparkpostPayload(values);
    updateAccount(payload);
    hideModal();
  };

  return (
    <EditModalRHF onSubmit={onSubmit}>
      <ConnectedInputField name={NAME} labelText="Name" />
      <AccountTypesRadioListField name={ESP} options={espOptions} disabled={true} />
      <GreyBorderedContainer>
        <ClearableConnectedInputField
          name={API_KEY}
          labelText="API key"
          wasEditedFieldName={EDIT_API_KEY}
        />
        <ConnectedInputField name={BINDING} labelText="IP Pool" />
        {esp === SERVICE_PROVIDERS.SPARKPOST_ELITE && (
          <ConnectedInputField
            name={API_ENDPOINT}
            labelText="Custom endpoint URL"
            placeholder="Example: https://<domain>.sparkpost.com"
          />
        )}
      </GreyBorderedContainer>
    </EditModalRHF>
  );
};
